import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Estudo } from './estudo';
import { EstudoService } from './estudo.service';
import { MatSnackBar } from '@angular/material';
import { RespostaListaDinamicaService } from 'unb-questionario-componente';
import { Resposta } from 'unb-questionario-componente';
import { SituacaoEnum } from '../util/situacao.enum';
import { Questionario } from 'unb-questionario-componente';
import { EstudoQuestionario } from './estudo-questionario';
import { EstudoQuestionarioEnum } from  '../util/estudo-questionario.enum';
import { ConfirmacaoDialog } from '../util/confirmacao.dialog';
import { Confirmacao } from '../util/confirmacao';
import { MatDialog } from '@angular/material';

@Component({
  templateUrl: './dados-pessoais-detail.component.html',
	selector: 'dados-pessoais-detail',
})

export class DadosPessoaisDetailComponent implements OnInit {
    @Input() estudo : Estudo;
    @Input() ehAluno : boolean ;
    @Input() botaoSelecionarPergunta: boolean;
    @Output() estudoEmitido: EventEmitter<Estudo> = new EventEmitter<Estudo>();
    @Output() perguntaSelecionadaEmitida: EventEmitter<number> = new EventEmitter<number>();
    @Output() questionarioDadosEmitido: EventEmitter<Questionario> = new EventEmitter<Questionario>();
    @Output() proximoEmitido: EventEmitter<number> = new EventEmitter<number>();
    @Output() anteriorEmitido: EventEmitter<number> = new EventEmitter<number>();

    public mostrarSalvar: boolean= true;
    public resposta: Resposta;
    public isLoading: boolean;
    public controlaPosSalvar: boolean= false;
    public carregando: boolean;
    public mensagemTela: string;
    // mantém o questionario montado na memória pra nao ser necessário carregar toda hora
    public questionarioCompleto:Questionario;
    public classProximo: string;

    constructor(private estudoService: EstudoService,
      public mensagem: MatSnackBar,
      private respostaService: RespostaListaDinamicaService,
      public dialog: MatDialog)  {
    }

    ngOnInit() {
      if(this.estudo && this.estudo.respostaQuestionarioPreliminar){
        this.carregaQuestionario();
        if(!this.estudo.respostaQuestionarioDadosPessoais){
          this.mostrarSalvar = true;
        }
      }else{
          this.mensagemTela= "Primeiro você deve preencher o formulário da aba '2.Estudo Preliminar'";
      }
  }

  carregaQuestionario(): void{
    // vejo se a classe pai jah tem o questionario Preliminar preenchido.
    if(this.estudo.questionarioDadosPessoais){
      this.carregaQuestionarioPeloPai();
    }else{ // se nao tiver, entao carrego ele aki em baixo.
      this.carregaQuestionarioPeloServico();
    }
  }

 carregaQuestionarioPeloPai(){
   this.questionarioCompleto = this.estudo.questionarioDadosPessoais;
   if(this.estudo.respostaQuestionarioPreliminar && this.estudo.respostaQuestionarioDadosPessoais){
     this.carregaResposta(this.estudo.respostaQuestionarioDadosPessoais);
   }
 }

 carregaQuestionarioPeloServico(){
   this.isLoading= true;
   this.estudoService.getQuestionario(this.estudo.respostaQuestionarioDadosPessoais, this.estudo.id, EstudoQuestionarioEnum.dadosPessoais)
     .subscribe((result: EstudoQuestionario) =>{
       this.questionarioCompleto = result.questionario;
       // emito o questionario montado pra classe pai. Assim, nao vou precisar carregar esse metodo novamente
       this.questionarioDadosEmitido.emit(result.questionario);
       if(result.resposta){
         this.resposta = result.resposta;
         this.controlaBotaoSalvar(result.resposta);
       }else{
         this.isLoading= false;
         this.classProximo = "disabled";
       }
   },
   error =>  this.erro(error));
 }

  private carregaResposta(idRespostaQuestionarioDadosPessoais: number){
      this.isLoading= true;
      this.respostaService.getRespostaCompletaPorPergunta(idRespostaQuestionarioDadosPessoais).subscribe(
        (result:Resposta) =>{
          this.resposta = result;
          this.controlaBotaoSalvar(result);
        },
        error =>  this.erro(error)
      );
  }


  private dadosPessoaisEmitido(event: Resposta){
    this.controlaPosSalvar = true;
    if(this.estudo.respostaQuestionarioDadosPessoais != event.id){
      this.estudo.respostaQuestionarioDadosPessoais = event.id;
      this.estudoService.update(this.estudo).subscribe(
        result => {
          this.estudo = result;
          if(this.questionarioCompleto){
            this.estudo.questionarioDadosPessoais =  this.questionarioCompleto;
          }
          this.estudoEmitido.emit(this.estudo);
          this.carregaSituacaoResposta(event);
        },
        error => {
          this.erro(error);
          this.controlaPosSalvar = false;
        }
      );
    }else{
      this.carregaSituacaoResposta(event);
    }
  }

  private controlaBotaoSalvar(result: Resposta){
      this.mostrarSalvar = this.estudoService.controlaBotaoSalvar(this.estudo.situacao, this.ehAluno);
      if(this.estudo.situacao == SituacaoEnum.NaoConcluido){
          this.carregaSituacaoResposta(result);
      }else{
        this.isLoading= false;
        this.classProximo = "";
      }
  }

  private carregaSituacaoResposta(resposta: Resposta){
    if(resposta){
      if(resposta.situacao == 1){
        this.classProximo = "disabled";
      }else{
        this.classProximo = "";
        if(this.estudo.situacao == SituacaoEnum.NaoConcluido){
          this.mensagemTela = "Clique no botão 'Próximo' para prosseguir."
        }
      }
      this.isLoading = false;
      this.controlaPosSalvar = false;
    }else{
      this.classProximo = "disabled";
    }
  }

  private perguntaEmitida(idPergunta: number){
    this.perguntaSelecionadaEmitida.emit(idPergunta);
  }

    // mostra erros na tela
  private erro(erro: string){
       this.mensagem.open(erro, 'X', {duration: 5000});
       this.isLoading=false;
   }

   proximo(){
     if(this.classProximo == ""){
       this.proximoEmitido.emit(3);
     }else{
       let confirmacao: Confirmacao = new Confirmacao("Primeiro você deve clicar no botão 'Finalizar' para continuar.", true);
       let dialogRef = this.dialog.open(ConfirmacaoDialog, {
           width: '400px',
           data: confirmacao,
         });

         dialogRef.afterClosed().subscribe(result => {
           if(result){
           }
         });
     }
   }

   anterior(){
     let confirmacao: Confirmacao = new Confirmacao("Atenção! Os dados que não foram salvos serão perdidos. Deseja voltar para tela anterior?", false);
     let dialogRef = this.dialog.open(ConfirmacaoDialog, {
         width: '400px',
         data: confirmacao,
       });

       dialogRef.afterClosed().subscribe(result => {
         if(result){
            this.anteriorEmitido.emit(3);
         }
       });
   }
}
